import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: string; output: string };
  Long: { input: any; output: any };
  Url: { input: string; output: string };
  _FieldSet: { input: any; output: any };
};

export type Appearance = {
  __typename?: 'Appearance';
  backgroundColor: Scalars['String']['output'];
  cardColor: Scalars['String']['output'];
  faviconUrl?: Maybe<Scalars['Url']['output']>;
  headingFontColor: Scalars['String']['output'];
  headingFontDetails: Font;
  horizontalLogoUrl?: Maybe<Scalars['Url']['output']>;
  iconColor: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['Url']['output']>;
  primaryColor: Scalars['String']['output'];
  textFontColor: Scalars['String']['output'];
  textFontDetails: Font;
  theme: Theme;
};

export type AppearanceTheme = {
  __typename?: 'AppearanceTheme';
  backgroundColor: Scalars['String']['output'];
  cardColor: Scalars['String']['output'];
  faviconUrl?: Maybe<Scalars['Url']['output']>;
  headingFontColor: Scalars['String']['output'];
  headingFontDetails: Font;
  horizontalLogoUrl?: Maybe<Scalars['Url']['output']>;
  iconColor: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['Url']['output']>;
  mode: Theme;
  primaryColor: Scalars['String']['output'];
  textFontColor: Scalars['String']['output'];
  textFontDetails: Font;
};

export type AuthStepBody = {
  provideAccessCode?: InputMaybe<ProvideAccessCodeStepInput>;
  provideEmail?: InputMaybe<ProvideEmailStepInput>;
  provideEmailForVerification?: InputMaybe<ProvideEmailForVerificationStepInput>;
  provideEmailVerificationCode?: InputMaybe<ProvideEmailVerificationCodeStepInput>;
  provideProtectionToken?: InputMaybe<ProvideProtectionTokenStepInput>;
  referrer?: InputMaybe<ReferrerStepInput>;
  register?: InputMaybe<RegisterStepInput>;
  ssoLogin?: InputMaybe<SsoLoginStepInput>;
};

export enum AuthStepFailureReason {
  ACCESS_DENIED = 'ACCESS_DENIED',
  FAILED_TO_SEND_VERIFICATION_EMAIL = 'FAILED_TO_SEND_VERIFICATION_EMAIL',
  INVALID_EMAIL = 'INVALID_EMAIL',
  INVALID_REGISTRATION_INPUT = 'INVALID_REGISTRATION_INPUT',
  PROTECTION_TOKEN_CHECK_INTERNAL_ERROR = 'PROTECTION_TOKEN_CHECK_INTERNAL_ERROR',
  PROTECTION_TOKEN_EXPIRED = 'PROTECTION_TOKEN_EXPIRED',
  SSO_TOKEN_NOT_PROVIDED = 'SSO_TOKEN_NOT_PROVIDED',
  X_REFERRER_HEADER_NOT_PROVIDED = 'X_REFERRER_HEADER_NOT_PROVIDED',
}

export type AuthStepInput = {
  authStepBody: AuthStepBody;
};

export enum AuthStepType {
  PROVIDE_ACCESS_CODE = 'PROVIDE_ACCESS_CODE',
  PROVIDE_EMAIL = 'PROVIDE_EMAIL',
  PROVIDE_EMAIL_FOR_VERIFICATION = 'PROVIDE_EMAIL_FOR_VERIFICATION',
  PROVIDE_EMAIL_VERIFICATION_CODE = 'PROVIDE_EMAIL_VERIFICATION_CODE',
  PROVIDE_PROTECTION_TOKEN = 'PROVIDE_PROTECTION_TOKEN',
  REFERRER = 'REFERRER',
  REGISTER = 'REGISTER',
  SSO_LOGIN = 'SSO_LOGIN',
}

export type AuthenticationMetadata = {
  __typename?: 'AuthenticationMetadata';
  email?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type AuthenticationSettings = {
  __typename?: 'AuthenticationSettings';
  idps?: Maybe<Array<Scalars['String']['output']>>;
  requiredRegistrationFields?: Maybe<Array<Maybe<RegistrationField>>>;
  showWatermarking?: Maybe<Scalars['Boolean']['output']>;
};

export type AuthenticationWorkflow = {
  __typename?: 'AuthenticationWorkflow';
  accessGranted: Scalars['Boolean']['output'];
  metadata: AuthenticationMetadata;
  pathways: Array<Pathway>;
  settings: AuthenticationSettings;
};

export type Chat = {
  __typename?: 'Chat';
  apiHost: Scalars['String']['output'];
  channelUrl: Scalars['String']['output'];
  chatProviderAccountId: Scalars['String']['output'];
  frozen: Scalars['Boolean']['output'];
  type: ChatType;
  useProvidedUsername: Scalars['Boolean']['output'];
  wsHost: Scalars['String']['output'];
};

export enum ChatType {
  ANONYMOUS = 'ANONYMOUS',
  MODERATED = 'MODERATED',
  UNMODERATED = 'UNMODERATED',
}

/**
 *  If this is the first call to this mutation, webcastId must be provided
 *  For subsequent calls, include the sessionToken (from the previous completeAuthSteps mutation) in the "X-Authorization-Token" header
 */
export type CompleteAuthStepsInput = {
  /**
   *  One call could complete multiple steps, as long as dependencies are satisfied
   *  by previous calls or steps inside this call
   */
  steps: Array<AuthStepInput>;
  webcastId: Scalars['ID']['input'];
};

export type CompleteAuthStepsProblem = {
  __typename?: 'CompleteAuthStepsProblem';
  code: CompleteAuthStepsProblemCode;
};

export enum CompleteAuthStepsProblemCode {
  INVALID_TOKEN = 'INVALID_TOKEN',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type CompleteAuthStepsResult = CompleteAuthStepsProblem | CompletedAuthSteps;

export type CompletedAuthSteps = {
  __typename?: 'CompletedAuthSteps';
  accessGranted: Scalars['Boolean']['output'];
  /**  at least one pathway needs to be completed to grant access */
  failedSteps: Array<FailedAuthStep>;
  /**  one-to-one with input steps */
  metadata: AuthenticationMetadata;
  pathways: Array<Pathway>;
  /**
   * A token used to track authentication steps for a user in subsequent calls.
   * - Provide this token in the "X-Authorization-Token" header for future requests.
   * - The token may be null if none of the steps in the pathways have been completed yet.
   */
  sessionToken?: Maybe<Scalars['String']['output']>;
};

export type ComplianceForm = {
  __typename?: 'ComplianceForm';
  text: Scalars['String']['output'];
};

export type ComplianceForms = {
  __typename?: 'ComplianceForms';
  customComplianceForm: ComplianceForm;
  defaultComplianceForm: ComplianceForm;
  includeDefaultComplianceForm: Scalars['Boolean']['output'];
};

export type CurrentSlide = {
  __typename?: 'CurrentSlide';
  /** Unique ID grouping all language versions for a given presentation */
  groupId: Scalars['String']['output'];
  /** Index of the current slide shown */
  index: Scalars['Int']['output'];
};

export type CustomLanguage = {
  __typename?: 'CustomLanguage';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DataProtectionForms = {
  __typename?: 'DataProtectionForms';
  entries: Array<LocalizedDataProtectionEntry>;
};

export type ECdnSettings = {
  __typename?: 'ECdnSettings';
  /** Represents Hive CDN settings. This property is set only when Hive CDN is enabled for a Webcast */
  hive?: Maybe<HiveSettings>;
  /** Represents Kollective CDN settings. This property is set only when Kollective CDN is enabled for a Webcast */
  kollective?: Maybe<KollectiveSettings>;
  /** Represents vBrick CDN settings. This property is set only when vBrick CDN is enabled for a Webcast */
  vBrick?: Maybe<VBrickSettings>;
};

export enum ErrorDetail {
  /**
   * The deadline expired before the operation could complete.
   *
   * For operations that change the state of the system, this error
   * may be returned even if the operation has completed successfully.
   * For example, a successful response from a server could have been
   * delayed long enough for the deadline to expire.
   *
   * HTTP Mapping: 504 Gateway Timeout
   * Error Type: UNAVAILABLE
   */
  DEADLINE_EXCEEDED = 'DEADLINE_EXCEEDED',
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   *
   * HTTP Mapping: 429 Too Many Requests or 420 Enhance Your Calm
   * Error Type: UNAVAILABLE
   */
  ENHANCE_YOUR_CALM = 'ENHANCE_YOUR_CALM',
  /**
   * The requested field is not found in the schema.
   *
   * This differs from `NOT_FOUND` in that `NOT_FOUND` should be used when a
   * query is valid, but is unable to return a result (if, for example, a
   * specific video id doesn't exist). `FIELD_NOT_FOUND` is intended to be
   * returned by the server to signify that the requested field is not known to exist.
   * This may be returned in lieu of failing the entire query.
   * See also `PERMISSION_DENIED` for cases where the
   * requested field is invalid only for the given user or class of users.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: BAD_REQUEST
   */
  FIELD_NOT_FOUND = 'FIELD_NOT_FOUND',
  /**
   * The client specified an invalid argument.
   *
   * Note that this differs from `FAILED_PRECONDITION`.
   * `INVALID_ARGUMENT` indicates arguments that are problematic
   * regardless of the state of the system (e.g., a malformed file name).
   *
   * HTTP Mapping: 400 Bad Request
   * Error Type: BAD_REQUEST
   */
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  /**
   * The provided cursor is not valid.
   *
   * The most common usage for this error is when a client is paginating
   * through a list that uses stateful cursors. In that case, the provided
   * cursor may be expired.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: NOT_FOUND
   */
  INVALID_CURSOR = 'INVALID_CURSOR',
  /**
   * Unable to perform operation because a required resource is missing.
   *
   * Example: Client is attempting to refresh a list, but the specified
   * list is expired. This requires an action by the client to get a new list.
   *
   * If the user is simply trying GET a resource that is not found,
   * use the NOT_FOUND error type. FAILED_PRECONDITION.MISSING_RESOURCE
   * is to be used particularly when the user is performing an operation
   * that requires a particular resource to exist.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   * Error Type: FAILED_PRECONDITION
   */
  MISSING_RESOURCE = 'MISSING_RESOURCE',
  /**
   * Service Error.
   *
   * There is a problem with an upstream service.
   *
   * This may be returned if a gateway receives an unknown error from a service
   * or if a service is unreachable.
   * If a request times out which waiting on a response from a service,
   * `DEADLINE_EXCEEDED` may be returned instead.
   * If a service returns a more specific error Type, the specific error Type may
   * be returned instead.
   *
   * HTTP Mapping: 502 Bad Gateway
   * Error Type: UNAVAILABLE
   */
  SERVICE_ERROR = 'SERVICE_ERROR',
  /**
   * Request failed due to network errors.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  TCP_FAILURE = 'TCP_FAILURE',
  /**
   * Request throttled based on server concurrency limits.
   *
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  THROTTLED_CONCURRENCY = 'THROTTLED_CONCURRENCY',
  /**
   * Request throttled based on server CPU limits
   *
   * HTTP Mapping: 503 Unavailable.
   * Error Type: UNAVAILABLE
   */
  THROTTLED_CPU = 'THROTTLED_CPU',
  /**
   * The operation is not implemented or is not currently supported/enabled.
   *
   * HTTP Mapping: 501 Not Implemented
   * Error Type: BAD_REQUEST
   */
  UNIMPLEMENTED = 'UNIMPLEMENTED',
  /**
   * Unknown error.
   *
   * This error should only be returned when no other error detail applies.
   * If a client sees an unknown errorDetail, it will be interpreted as UNKNOWN.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  UNKNOWN = 'UNKNOWN',
}

export enum ErrorType {
  /**
   * Bad Request.
   *
   * There is a problem with the request.
   * Retrying the same request is not likely to succeed.
   * An example would be a query or argument that cannot be deserialized.
   *
   * HTTP Mapping: 400 Bad Request
   */
  BAD_REQUEST = 'BAD_REQUEST',
  /**
   * The operation was rejected because the system is not in a state
   * required for the operation's execution.  For example, the directory
   * to be deleted is non-empty, an rmdir operation is applied to
   * a non-directory, etc.
   *
   * Service implementers can use the following guidelines to decide
   * between `FAILED_PRECONDITION` and `UNAVAILABLE`:
   *
   * - Use `UNAVAILABLE` if the client can retry just the failing call.
   * - Use `FAILED_PRECONDITION` if the client should not retry until
   * the system state has been explicitly fixed.  E.g., if an "rmdir"
   *      fails because the directory is non-empty, `FAILED_PRECONDITION`
   * should be returned since the client should not retry unless
   * the files are deleted from the directory.
   *
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   */
  FAILED_PRECONDITION = 'FAILED_PRECONDITION',
  /**
   * Internal error.
   *
   * An unexpected internal error was encountered. This means that some
   * invariants expected by the underlying system have been broken.
   * This error code is reserved for serious errors.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  INTERNAL = 'INTERNAL',
  /**
   * The requested entity was not found.
   *
   * This could apply to a resource that has never existed (e.g. bad resource id),
   * or a resource that no longer exists (e.g. cache expired.)
   *
   * Note to server developers: if a request is denied for an entire class
   * of users, such as gradual feature rollout or undocumented allowlist,
   * `NOT_FOUND` may be used. If a request is denied for some users within
   * a class of users, such as user-based access control, `PERMISSION_DENIED`
   * must be used.
   *
   * HTTP Mapping: 404 Not Found
   */
  NOT_FOUND = 'NOT_FOUND',
  /**
   * The caller does not have permission to execute the specified
   * operation.
   *
   * `PERMISSION_DENIED` must not be used for rejections
   * caused by exhausting some resource or quota.
   * `PERMISSION_DENIED` must not be used if the caller
   * cannot be identified (use `UNAUTHENTICATED`
   * instead for those errors).
   *
   * This error Type does not imply the
   * request is valid or the requested entity exists or satisfies
   * other pre-conditions.
   *
   * HTTP Mapping: 403 Forbidden
   */
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  /**
   * The request does not have valid authentication credentials.
   *
   * This is intended to be returned only for routes that require
   * authentication.
   *
   * HTTP Mapping: 401 Unauthorized
   */
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  /**
   * Currently Unavailable.
   *
   * The service is currently unavailable.  This is most likely a
   * transient condition, which can be corrected by retrying with
   * a backoff.
   *
   * HTTP Mapping: 503 Unavailable
   */
  UNAVAILABLE = 'UNAVAILABLE',
  /**
   * Unknown error.
   *
   * For example, this error may be returned when
   * an error code received from another address space belongs to
   * an error space that is not known in this address space.  Also
   * errors raised by APIs that do not return enough error information
   * may be converted to this error.
   *
   * If a client sees an unknown errorType, it will be interpreted as UNKNOWN.
   * Unknown errors MUST NOT trigger any special behavior. These MAY be treated
   * by an implementation as being equivalent to INTERNAL.
   *
   * When possible, a more specific error should be provided.
   *
   * HTTP Mapping: 520 Unknown Error
   */
  UNKNOWN = 'UNKNOWN',
}

export type FailedAuthStep = {
  __typename?: 'FailedAuthStep';
  reason: AuthStepFailureReason;
  stepType: AuthStepType;
};

export type Font = {
  __typename?: 'Font';
  downloadLink?: Maybe<Scalars['Url']['output']>;
  id: Scalars['ID']['output'];
};

export type HiveSettings = {
  __typename?: 'HiveSettings';
  backup?: Maybe<HiveToken>;
  primary: HiveToken;
};

export type HiveToken = {
  __typename?: 'HiveToken';
  jwt: Scalars['String']['output'];
  manifest: Scalars['String']['output'];
};

export type KollectiveSettings = {
  __typename?: 'KollectiveSettings';
  jitc: Scalars['String']['output'];
  jwt: Scalars['String']['output'];
};

export type Language = CustomLanguage | StandardLanguage;

export type LiveStreaming = {
  __typename?: 'LiveStreaming';
  streams: Array<Stream>;
};

export type LocalizedDataProtectionEntry = {
  __typename?: 'LocalizedDataProtectionEntry';
  language: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type LocalizedText = {
  __typename?: 'LocalizedText';
  language: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  completeAuthSteps: CompleteAuthStepsResult;
};

export type MutationCompleteAuthStepsArgs = {
  input: CompleteAuthStepsInput;
};

export type Pathway = {
  __typename?: 'Pathway';
  /**  These steps must ALL be completed */
  isInProgress: Scalars['Boolean']['output'];
  requiredNextSteps: Array<AuthStepType>;
};

export type Playback = {
  __typename?: 'Playback';
  backupUrl?: Maybe<Scalars['Url']['output']>;
  ecdnSettings?: Maybe<ECdnSettings>;
  primaryUrl: Scalars['Url']['output'];
  token: Scalars['String']['output'];
  /** @deprecated Use primaryUrl instead */
  url: Scalars['Url']['output'];
};

export enum PlaybackState {
  NOT_READY = 'NOT_READY',
  READY = 'READY',
  UNKNOWN = 'UNKNOWN',
}

export type Presentation = {
  __typename?: 'Presentation';
  downloadLink: Scalars['Url']['output'];
  /** Unique ID grouping all language versions for a given presentation. */
  groupId: Scalars['String']['output'];
  /** Language (ISO 639-1 code) */
  language: Scalars['String']['output'];
  /** Extracted slide image URLs */
  slides?: Maybe<Array<Maybe<PresentationSlide>>>;
  /** Original name of presentation file */
  sourceFileName: Scalars['String']['output'];
};

export type PresentationSlide = {
  __typename?: 'PresentationSlide';
  downloadUrl: Scalars['Url']['output'];
  index: Scalars['Int']['output'];
  thumbnailDownloadUrl: Scalars['Url']['output'];
};

export type ProvideAccessCodeStepInput = {
  accessCode: Scalars['String']['input'];
};

export type ProvideEmailForVerificationStepInput = {
  email: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};

export type ProvideEmailStepInput = {
  email: Scalars['String']['input'];
};

export type ProvideEmailVerificationCodeStepInput = {
  email: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type ProvideProtectionTokenStepInput = {
  hmacToken: Scalars['String']['input'];
};

export type PushedSlide = {
  __typename?: 'PushedSlide';
  /** Unique ID grouping all language versions for a given presentation */
  groupId: Scalars['String']['output'];
  /** Index of the current slide shown */
  index: Scalars['Int']['output'];
  /** Offset in ms since webcast went live */
  offsetInMs: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  _service: _Service;
  webcast?: Maybe<Webcast>;
  /**  Include sessionToken in the "X-Authorization-Token" header, if any completeAuthSteps mutation was called before */
  webcastNewAuth?: Maybe<Webcast>;
};

export type QueryWebcastArgs = {
  webcastId: Scalars['ID']['input'];
};

export type QueryWebcastNewAuthArgs = {
  webcastId: Scalars['ID']['input'];
};

export type ReferrerStepInput = {
  _?: InputMaybe<Scalars['Int']['input']>;
};

export type RegisterStepInput = {
  bankCode?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  departmentName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum RegistrationField {
  BANK_CODE = 'BANK_CODE',
  COMPANY_NAME = 'COMPANY_NAME',
  COUNTRY = 'COUNTRY',
  DEPARTMENT_NAME = 'DEPARTMENT_NAME',
  EMAIL = 'EMAIL',
  FIRST_AND_LAST_NAME = 'FIRST_AND_LAST_NAME',
  JOB_TITLE = 'JOB_TITLE',
  PHONE_NUMBER = 'PHONE_NUMBER',
}

export type SecurityPolicy = {
  __typename?: 'SecurityPolicy';
  accessGranted?: Maybe<Scalars['Boolean']['output']>;
  idps?: Maybe<Array<Scalars['String']['output']>>;
  requireEmailVerification?: Maybe<Scalars['Boolean']['output']>;
  requiredRegistrationFields?: Maybe<Array<Maybe<RegistrationField>>>;
  showWatermarking?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<SecurityPolicyType>;
};

export enum SecurityPolicyType {
  ACCESS_CODE = 'ACCESS_CODE',
  EMAIL_REGISTRATION = 'EMAIL_REGISTRATION',
  EMAIL_WHITELIST = 'EMAIL_WHITELIST',
  NONE = 'NONE',
  REFERRER_PROTECTION = 'REFERRER_PROTECTION',
  SINGLE_SIGN_ON = 'SINGLE_SIGN_ON',
  TOKEN_PROTECTION = 'TOKEN_PROTECTION',
}

export type SsoLoginStepInput = {
  _?: InputMaybe<Scalars['Int']['input']>;
};

export type StandardLanguage = {
  __typename?: 'StandardLanguage';
  code: Scalars['String']['output'];
};

export enum State {
  LIVE = 'LIVE',
  LIVE_TEST = 'LIVE_TEST',
  POSTLIVE = 'POSTLIVE',
  PRELIVE = 'PRELIVE',
}

export type Stream = {
  __typename?: 'Stream';
  backupStatus: StreamStatus;
  metadata?: Maybe<StreamMetadata>;
  playback: Playback;
  /**
   * URL for playing back the stream
   * @deprecated Use 'playback' property instead
   */
  playbackUrl: Scalars['Url']['output'];
  primaryStatus: StreamStatus;
  viewerSourceMode: ViewerSourceMode;
};

export type StreamMetadata = {
  __typename?: 'StreamMetadata';
  language?: Maybe<Scalars['String']['output']>;
};

export enum StreamState {
  CONNECTED = 'CONNECTED',
  NOT_CONNECTED = 'NOT_CONNECTED',
  UNKNOWN = 'UNKNOWN',
}

export type StreamStatus = {
  __typename?: 'StreamStatus';
  playbackState: PlaybackState;
  streamState: StreamState;
};

export type Streaming = {
  __typename?: 'Streaming';
  live?: Maybe<LiveStreaming>;
  vod?: Maybe<VodStreaming>;
};

export type TermsAndConditions = {
  __typename?: 'TermsAndConditions';
  content: Scalars['String']['output'];
  header?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  locale: Scalars['String']['output'];
  subheader?: Maybe<Scalars['String']['output']>;
};

export enum Theme {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
}

export type VBrickSettings = {
  __typename?: 'VBrickSettings';
  vBrickOmnicacheUris?: Maybe<Array<Scalars['String']['output']>>;
  vbrickApiKey?: Maybe<Scalars['String']['output']>;
  vbrickApiSecret?: Maybe<Scalars['String']['output']>;
  vbrickHostName?: Maybe<Scalars['String']['output']>;
  vbrickJwtKeyName?: Maybe<Scalars['String']['output']>;
};

export type VideoReference = {
  __typename?: 'VideoReference';
  channelId: Scalars['ID']['output'];
  playoutUrl: Scalars['String']['output'];
  token?: Maybe<Scalars['String']['output']>;
  videoId: Scalars['ID']['output'];
};

export enum ViewerSourceMode {
  AUTO = 'AUTO',
  FORCE_BACKUP = 'FORCE_BACKUP',
  FORCE_PRIMARY = 'FORCE_PRIMARY',
}

export type VodChapter = {
  __typename?: 'VodChapter';
  id: Scalars['ID']['output'];
  offsetInMs: Scalars['Long']['output'];
  thumbnailUrl?: Maybe<Scalars['Url']['output']>;
  titles: Array<LocalizedText>;
};

export type VodSlideMarker = {
  __typename?: 'VodSlideMarker';
  groupId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  offsetInMs: Scalars['Long']['output'];
};

export type VodStream = {
  __typename?: 'VodStream';
  metadata: StreamMetadata;
  offsetInSeconds: Scalars['Int']['output'];
  video?: Maybe<VideoReference>;
  videoVodManifestUrl?: Maybe<Scalars['Url']['output']>;
};

export type VodStreaming = {
  __typename?: 'VodStreaming';
  chapters: Array<VodChapter>;
  enabled: Scalars['Boolean']['output'];
  slideMarkers: Array<VodSlideMarker>;
  streams?: Maybe<Array<VodStream>>;
};

export type Webcast = {
  __typename?: 'Webcast';
  accountId: Scalars['String']['output'];
  additionalLangs: Array<Language>;
  /** Deprecated. Use `additionalLangs` instead */
  additionalLanguages: Array<Scalars['String']['output']>;
  /** @deprecated Use `theme` instead */
  appearance?: Maybe<Appearance>;
  authenticationWorkflow: AuthenticationWorkflow;
  chat?: Maybe<Chat>;
  complianceForms?: Maybe<ComplianceForms>;
  contents: Array<WebcastContent>;
  currentSlide?: Maybe<CurrentSlide>;
  dataProtectionForms?: Maybe<DataProtectionForms>;
  durationInMinutes: Scalars['Int']['output'];
  hideWebcastSchedule: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lsproId: Scalars['String']['output'];
  plannedStartAt: Scalars['DateTime']['output'];
  presentations: Array<Presentation>;
  primaryLang: Language;
  /** Deprecated. Use `primaryLang` instead */
  primaryLanguage: Scalars['String']['output'];
  pushedSlides: Array<PushedSlide>;
  /**
   * Deprecated. Use `authenticationWorkflow` instead
   * @deprecated Obsolete
   */
  securityPolicies: Array<SecurityPolicy>;
  sharingUrl?: Maybe<Scalars['Url']['output']>;
  state: State;
  streaming?: Maybe<Streaming>;
  termsAndConditions: Array<TermsAndConditions>;
  theme?: Maybe<AppearanceTheme>;
};

export type WebcastContent = {
  __typename?: 'WebcastContent';
  language: Scalars['String']['output'];
  live: WebcastLiveContent;
  postLive: WebcastPostLiveContent;
  preLive: WebcastPreLiveContent;
  title?: Maybe<Scalars['String']['output']>;
};

export type WebcastLiveContent = {
  __typename?: 'WebcastLiveContent';
  coverImageUrl?: Maybe<Scalars['Url']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type WebcastPostLiveContent = {
  __typename?: 'WebcastPostLiveContent';
  coverImageUrl?: Maybe<Scalars['Url']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  video?: Maybe<VideoReference>;
  videoVodManifestUrl?: Maybe<Scalars['Url']['output']>;
};

export type WebcastPreLiveContent = {
  __typename?: 'WebcastPreLiveContent';
  coverImageUrl?: Maybe<Scalars['Url']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  video?: Maybe<VideoReference>;
  videoVodManifestUrl?: Maybe<Scalars['Url']['output']>;
};

export type _Service = {
  __typename?: '_Service';
  sdl: Scalars['String']['output'];
};

export type PollForPlaybackStateNewAuthQueryVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type PollForPlaybackStateNewAuthQuery = {
  __typename?: 'Query';
  webcastNewAuth?:
    | {
        __typename?: 'Webcast';
        streaming?:
          | {
              __typename?: 'Streaming';
              live?:
                | {
                    __typename?: 'LiveStreaming';
                    streams: Array<{
                      __typename?: 'Stream';
                      viewerSourceMode: ViewerSourceMode;
                      metadata?:
                        | { __typename?: 'StreamMetadata'; language?: string | null | undefined }
                        | null
                        | undefined;
                      primaryStatus: { __typename?: 'StreamStatus'; playbackState: PlaybackState };
                      backupStatus: { __typename?: 'StreamStatus'; playbackState: PlaybackState };
                    }>;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetWebcastViewerNewAuthQueryVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type GetWebcastViewerNewAuthQuery = {
  __typename?: 'Query';
  webcastNewAuth?:
    | {
        __typename?: 'Webcast';
        id: string;
        lsproId: string;
        accountId: string;
        state: State;
        plannedStartAt: string;
        durationInMinutes: number;
        sharingUrl?: string | null | undefined;
        hideWebcastSchedule: boolean;
        primaryLang:
          | { __typename?: 'CustomLanguage'; code: string; name: string }
          | { __typename?: 'StandardLanguage'; code: string };
        additionalLangs: Array<
          | { __typename?: 'CustomLanguage'; code: string; name: string }
          | { __typename?: 'StandardLanguage'; code: string }
        >;
        theme?:
          | {
              __typename?: 'AppearanceTheme';
              primaryColor: string;
              backgroundColor: string;
              cardColor: string;
              iconColor: string;
              textFontColor: string;
              headingFontColor: string;
              mode: Theme;
              logoUrl?: string | null | undefined;
              horizontalLogoUrl?: string | null | undefined;
              faviconUrl?: string | null | undefined;
              textFontDetails: { __typename?: 'Font'; id: string; downloadLink?: string | null | undefined };
              headingFontDetails: { __typename?: 'Font'; id: string; downloadLink?: string | null | undefined };
            }
          | null
          | undefined;
        complianceForms?:
          | {
              __typename?: 'ComplianceForms';
              includeDefaultComplianceForm: boolean;
              defaultComplianceForm: { __typename?: 'ComplianceForm'; text: string };
              customComplianceForm: { __typename?: 'ComplianceForm'; text: string };
            }
          | null
          | undefined;
        contents: Array<{
          __typename?: 'WebcastContent';
          language: string;
          title?: string | null | undefined;
          preLive: {
            __typename?: 'WebcastPreLiveContent';
            description?: string | null | undefined;
            coverImageUrl?: string | null | undefined;
            videoVodManifestUrl?: string | null | undefined;
            video?:
              | {
                  __typename?: 'VideoReference';
                  videoId: string;
                  channelId: string;
                  token?: string | null | undefined;
                  playoutUrl: string;
                }
              | null
              | undefined;
          };
          live: {
            __typename?: 'WebcastLiveContent';
            description?: string | null | undefined;
            coverImageUrl?: string | null | undefined;
          };
          postLive: {
            __typename?: 'WebcastPostLiveContent';
            description?: string | null | undefined;
            coverImageUrl?: string | null | undefined;
            videoVodManifestUrl?: string | null | undefined;
            video?:
              | {
                  __typename?: 'VideoReference';
                  videoId: string;
                  channelId: string;
                  token?: string | null | undefined;
                  playoutUrl: string;
                }
              | null
              | undefined;
          };
        }>;
        termsAndConditions: Array<{
          __typename?: 'TermsAndConditions';
          content: string;
          header?: string | null | undefined;
          link?: string | null | undefined;
          locale: string;
          subheader?: string | null | undefined;
        }>;
        dataProtectionForms?:
          | {
              __typename?: 'DataProtectionForms';
              entries: Array<{ __typename?: 'LocalizedDataProtectionEntry'; language: string; text: string }>;
            }
          | null
          | undefined;
        chat?:
          | {
              __typename?: 'Chat';
              chatProviderAccountId: string;
              channelUrl: string;
              type: ChatType;
              useProvidedUsername: boolean;
              apiHost: string;
              wsHost: string;
            }
          | null
          | undefined;
        authenticationWorkflow: {
          __typename?: 'AuthenticationWorkflow';
          accessGranted: boolean;
          settings: {
            __typename?: 'AuthenticationSettings';
            idps?: Array<string> | null | undefined;
            requiredRegistrationFields?: Array<RegistrationField | null | undefined> | null | undefined;
            showWatermarking?: boolean | null | undefined;
          };
          metadata: {
            __typename?: 'AuthenticationMetadata';
            email?: string | null | undefined;
            firstName?: string | null | undefined;
            lastName?: string | null | undefined;
            employeeId?: string | null | undefined;
          };
          pathways: Array<{ __typename?: 'Pathway'; requiredNextSteps: Array<AuthStepType>; isInProgress: boolean }>;
        };
      }
    | null
    | undefined;
};

export type GetWebcastStreamNewAuthQueryVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type GetWebcastStreamNewAuthQuery = {
  __typename?: 'Query';
  webcastNewAuth?:
    | {
        __typename?: 'Webcast';
        id: string;
        streaming?:
          | {
              __typename?: 'Streaming';
              live?:
                | {
                    __typename?: 'LiveStreaming';
                    streams: Array<{
                      __typename?: 'Stream';
                      playback: {
                        __typename?: 'Playback';
                        primaryUrl: string;
                        backupUrl?: string | null | undefined;
                        token: string;
                        ecdnSettings?:
                          | {
                              __typename?: 'ECdnSettings';
                              hive?:
                                | {
                                    __typename?: 'HiveSettings';
                                    primary: { __typename?: 'HiveToken'; jwt: string; manifest: string };
                                    backup?:
                                      | { __typename?: 'HiveToken'; jwt: string; manifest: string }
                                      | null
                                      | undefined;
                                  }
                                | null
                                | undefined;
                              vBrick?:
                                | {
                                    __typename?: 'VBrickSettings';
                                    vbrickApiKey?: string | null | undefined;
                                    vbrickHostName?: string | null | undefined;
                                    vbrickApiSecret?: string | null | undefined;
                                    vbrickJwtKeyName?: string | null | undefined;
                                    vBrickOmnicacheUris?: Array<string> | null | undefined;
                                  }
                                | null
                                | undefined;
                              kollective?:
                                | { __typename?: 'KollectiveSettings'; jwt: string; jitc: string }
                                | null
                                | undefined;
                            }
                          | null
                          | undefined;
                      };
                      metadata?:
                        | { __typename?: 'StreamMetadata'; language?: string | null | undefined }
                        | null
                        | undefined;
                    }>;
                  }
                | null
                | undefined;
              vod?:
                | {
                    __typename?: 'VodStreaming';
                    enabled: boolean;
                    streams?:
                      | Array<{
                          __typename?: 'VodStream';
                          videoVodManifestUrl?: string | null | undefined;
                          offsetInSeconds: number;
                          metadata: { __typename?: 'StreamMetadata'; language?: string | null | undefined };
                          video?:
                            | {
                                __typename?: 'VideoReference';
                                channelId: string;
                                videoId: string;
                                token?: string | null | undefined;
                                playoutUrl: string;
                              }
                            | null
                            | undefined;
                        }>
                      | null
                      | undefined;
                    slideMarkers: Array<{
                      __typename?: 'VodSlideMarker';
                      groupId: string;
                      id: string;
                      index: number;
                      offsetInMs: any;
                    }>;
                    chapters: Array<{
                      __typename?: 'VodChapter';
                      id: string;
                      offsetInMs: any;
                      thumbnailUrl?: string | null | undefined;
                      titles: Array<{ __typename?: 'LocalizedText'; language: string; text: string }>;
                    }>;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetWebcastViewerSlidesNewAuthQueryVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type GetWebcastViewerSlidesNewAuthQuery = {
  __typename?: 'Query';
  webcastNewAuth?:
    | {
        __typename?: 'Webcast';
        id: string;
        presentations: Array<{
          __typename?: 'Presentation';
          language: string;
          groupId: string;
          slides?:
            | Array<
                | { __typename?: 'PresentationSlide'; index: number; downloadUrl: string; thumbnailDownloadUrl: string }
                | null
                | undefined
              >
            | null
            | undefined;
        }>;
        currentSlide?: { __typename?: 'CurrentSlide'; groupId: string; index: number } | null | undefined;
        pushedSlides: Array<{ __typename?: 'PushedSlide'; groupId: string; index: number; offsetInMs: number }>;
      }
    | null
    | undefined;
};

export type CompleteAuthStepsMutationVariables = Exact<{
  input: CompleteAuthStepsInput;
}>;

export type CompleteAuthStepsMutation = {
  __typename?: 'Mutation';
  completeAuthSteps:
    | { __typename?: 'CompleteAuthStepsProblem'; code: CompleteAuthStepsProblemCode }
    | {
        __typename?: 'CompletedAuthSteps';
        accessGranted: boolean;
        sessionToken?: string | null | undefined;
        pathways: Array<{ __typename?: 'Pathway'; requiredNextSteps: Array<AuthStepType>; isInProgress: boolean }>;
        failedSteps: Array<{ __typename?: 'FailedAuthStep'; stepType: AuthStepType; reason: AuthStepFailureReason }>;
      };
};

export const PollForPlaybackStateNewAuthDocument = gql`
  query PollForPlaybackStateNewAuth($webcastId: ID!) {
    webcastNewAuth(webcastId: $webcastId) {
      streaming {
        live {
          streams {
            metadata {
              language
            }
            primaryStatus {
              playbackState
            }
            backupStatus {
              playbackState
            }
            viewerSourceMode
          }
        }
      }
    }
  }
`;

/**
 * __usePollForPlaybackStateNewAuthQuery__
 *
 * To run a query within a React component, call `usePollForPlaybackStateNewAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollForPlaybackStateNewAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollForPlaybackStateNewAuthQuery({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function usePollForPlaybackStateNewAuthQuery(
  baseOptions: Apollo.QueryHookOptions<PollForPlaybackStateNewAuthQuery, PollForPlaybackStateNewAuthQueryVariables> &
    ({ variables: PollForPlaybackStateNewAuthQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PollForPlaybackStateNewAuthQuery, PollForPlaybackStateNewAuthQueryVariables>(
    PollForPlaybackStateNewAuthDocument,
    options
  );
}
export function usePollForPlaybackStateNewAuthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PollForPlaybackStateNewAuthQuery, PollForPlaybackStateNewAuthQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PollForPlaybackStateNewAuthQuery, PollForPlaybackStateNewAuthQueryVariables>(
    PollForPlaybackStateNewAuthDocument,
    options
  );
}
// @ts-ignore
export function usePollForPlaybackStateNewAuthSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PollForPlaybackStateNewAuthQuery,
    PollForPlaybackStateNewAuthQueryVariables
  >
): Apollo.UseSuspenseQueryResult<PollForPlaybackStateNewAuthQuery, PollForPlaybackStateNewAuthQueryVariables>;
export function usePollForPlaybackStateNewAuthSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PollForPlaybackStateNewAuthQuery, PollForPlaybackStateNewAuthQueryVariables>
): Apollo.UseSuspenseQueryResult<
  PollForPlaybackStateNewAuthQuery | undefined,
  PollForPlaybackStateNewAuthQueryVariables
>;
export function usePollForPlaybackStateNewAuthSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PollForPlaybackStateNewAuthQuery, PollForPlaybackStateNewAuthQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PollForPlaybackStateNewAuthQuery, PollForPlaybackStateNewAuthQueryVariables>(
    PollForPlaybackStateNewAuthDocument,
    options
  );
}
export type PollForPlaybackStateNewAuthQueryHookResult = ReturnType<typeof usePollForPlaybackStateNewAuthQuery>;
export type PollForPlaybackStateNewAuthLazyQueryHookResult = ReturnType<typeof usePollForPlaybackStateNewAuthLazyQuery>;
export type PollForPlaybackStateNewAuthSuspenseQueryHookResult = ReturnType<
  typeof usePollForPlaybackStateNewAuthSuspenseQuery
>;
export type PollForPlaybackStateNewAuthQueryResult = Apollo.QueryResult<
  PollForPlaybackStateNewAuthQuery,
  PollForPlaybackStateNewAuthQueryVariables
>;
export const GetWebcastViewerNewAuthDocument = gql`
  query GetWebcastViewerNewAuth($webcastId: ID!) {
    webcastNewAuth(webcastId: $webcastId) {
      id
      lsproId
      accountId
      state
      plannedStartAt
      durationInMinutes
      sharingUrl
      hideWebcastSchedule
      primaryLang {
        ... on StandardLanguage {
          code
        }
        ... on CustomLanguage {
          code
          name
        }
      }
      additionalLangs {
        ... on StandardLanguage {
          code
        }
        ... on CustomLanguage {
          code
          name
        }
      }
      theme {
        primaryColor
        backgroundColor
        cardColor
        iconColor
        textFontColor
        textFontDetails {
          id
          downloadLink
        }
        headingFontColor
        headingFontDetails {
          id
          downloadLink
        }
        mode
        logoUrl
        horizontalLogoUrl
        faviconUrl
      }
      complianceForms {
        includeDefaultComplianceForm
        defaultComplianceForm {
          text
        }
        customComplianceForm {
          text
        }
      }
      contents {
        language
        title
        preLive {
          description
          coverImageUrl
          video {
            videoId
            channelId
            token
            playoutUrl
          }
          videoVodManifestUrl
        }
        live {
          description
          coverImageUrl
        }
        postLive {
          description
          coverImageUrl
          video {
            videoId
            channelId
            token
            playoutUrl
          }
          videoVodManifestUrl
        }
      }
      termsAndConditions {
        content
        header
        link
        locale
        subheader
      }
      dataProtectionForms {
        entries {
          language
          text
        }
      }
      chat {
        chatProviderAccountId
        channelUrl
        type
        useProvidedUsername
        apiHost
        wsHost
      }
      authenticationWorkflow {
        accessGranted
        settings {
          idps
          requiredRegistrationFields
          showWatermarking
        }
        metadata {
          email
          firstName
          lastName
          employeeId
        }
        pathways {
          requiredNextSteps
          isInProgress
        }
      }
    }
  }
`;

/**
 * __useGetWebcastViewerNewAuthQuery__
 *
 * To run a query within a React component, call `useGetWebcastViewerNewAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebcastViewerNewAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebcastViewerNewAuthQuery({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function useGetWebcastViewerNewAuthQuery(
  baseOptions: Apollo.QueryHookOptions<GetWebcastViewerNewAuthQuery, GetWebcastViewerNewAuthQueryVariables> &
    ({ variables: GetWebcastViewerNewAuthQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWebcastViewerNewAuthQuery, GetWebcastViewerNewAuthQueryVariables>(
    GetWebcastViewerNewAuthDocument,
    options
  );
}
export function useGetWebcastViewerNewAuthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWebcastViewerNewAuthQuery, GetWebcastViewerNewAuthQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWebcastViewerNewAuthQuery, GetWebcastViewerNewAuthQueryVariables>(
    GetWebcastViewerNewAuthDocument,
    options
  );
}
// @ts-ignore
export function useGetWebcastViewerNewAuthSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebcastViewerNewAuthQuery, GetWebcastViewerNewAuthQueryVariables>
): Apollo.UseSuspenseQueryResult<GetWebcastViewerNewAuthQuery, GetWebcastViewerNewAuthQueryVariables>;
export function useGetWebcastViewerNewAuthSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWebcastViewerNewAuthQuery, GetWebcastViewerNewAuthQueryVariables>
): Apollo.UseSuspenseQueryResult<GetWebcastViewerNewAuthQuery | undefined, GetWebcastViewerNewAuthQueryVariables>;
export function useGetWebcastViewerNewAuthSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWebcastViewerNewAuthQuery, GetWebcastViewerNewAuthQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWebcastViewerNewAuthQuery, GetWebcastViewerNewAuthQueryVariables>(
    GetWebcastViewerNewAuthDocument,
    options
  );
}
export type GetWebcastViewerNewAuthQueryHookResult = ReturnType<typeof useGetWebcastViewerNewAuthQuery>;
export type GetWebcastViewerNewAuthLazyQueryHookResult = ReturnType<typeof useGetWebcastViewerNewAuthLazyQuery>;
export type GetWebcastViewerNewAuthSuspenseQueryHookResult = ReturnType<typeof useGetWebcastViewerNewAuthSuspenseQuery>;
export type GetWebcastViewerNewAuthQueryResult = Apollo.QueryResult<
  GetWebcastViewerNewAuthQuery,
  GetWebcastViewerNewAuthQueryVariables
>;
export const GetWebcastStreamNewAuthDocument = gql`
  query GetWebcastStreamNewAuth($webcastId: ID!) {
    webcastNewAuth(webcastId: $webcastId) {
      id
      streaming {
        live {
          streams {
            playback {
              primaryUrl
              backupUrl
              token
              ecdnSettings {
                hive {
                  primary {
                    jwt
                    manifest
                  }
                  backup {
                    jwt
                    manifest
                  }
                }
                vBrick {
                  vbrickApiKey
                  vbrickHostName
                  vbrickApiSecret
                  vbrickJwtKeyName
                  vBrickOmnicacheUris
                }
                kollective {
                  jwt
                  jitc
                }
              }
            }
            metadata {
              language
            }
          }
        }
        vod {
          enabled
          streams {
            metadata {
              language
            }
            video {
              channelId
              videoId
              token
              playoutUrl
            }
            videoVodManifestUrl
            offsetInSeconds
          }
          slideMarkers {
            groupId
            id
            index
            offsetInMs
          }
          chapters {
            id
            offsetInMs
            thumbnailUrl
            titles {
              language
              text
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetWebcastStreamNewAuthQuery__
 *
 * To run a query within a React component, call `useGetWebcastStreamNewAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebcastStreamNewAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebcastStreamNewAuthQuery({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function useGetWebcastStreamNewAuthQuery(
  baseOptions: Apollo.QueryHookOptions<GetWebcastStreamNewAuthQuery, GetWebcastStreamNewAuthQueryVariables> &
    ({ variables: GetWebcastStreamNewAuthQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWebcastStreamNewAuthQuery, GetWebcastStreamNewAuthQueryVariables>(
    GetWebcastStreamNewAuthDocument,
    options
  );
}
export function useGetWebcastStreamNewAuthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWebcastStreamNewAuthQuery, GetWebcastStreamNewAuthQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWebcastStreamNewAuthQuery, GetWebcastStreamNewAuthQueryVariables>(
    GetWebcastStreamNewAuthDocument,
    options
  );
}
// @ts-ignore
export function useGetWebcastStreamNewAuthSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebcastStreamNewAuthQuery, GetWebcastStreamNewAuthQueryVariables>
): Apollo.UseSuspenseQueryResult<GetWebcastStreamNewAuthQuery, GetWebcastStreamNewAuthQueryVariables>;
export function useGetWebcastStreamNewAuthSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWebcastStreamNewAuthQuery, GetWebcastStreamNewAuthQueryVariables>
): Apollo.UseSuspenseQueryResult<GetWebcastStreamNewAuthQuery | undefined, GetWebcastStreamNewAuthQueryVariables>;
export function useGetWebcastStreamNewAuthSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWebcastStreamNewAuthQuery, GetWebcastStreamNewAuthQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWebcastStreamNewAuthQuery, GetWebcastStreamNewAuthQueryVariables>(
    GetWebcastStreamNewAuthDocument,
    options
  );
}
export type GetWebcastStreamNewAuthQueryHookResult = ReturnType<typeof useGetWebcastStreamNewAuthQuery>;
export type GetWebcastStreamNewAuthLazyQueryHookResult = ReturnType<typeof useGetWebcastStreamNewAuthLazyQuery>;
export type GetWebcastStreamNewAuthSuspenseQueryHookResult = ReturnType<typeof useGetWebcastStreamNewAuthSuspenseQuery>;
export type GetWebcastStreamNewAuthQueryResult = Apollo.QueryResult<
  GetWebcastStreamNewAuthQuery,
  GetWebcastStreamNewAuthQueryVariables
>;
export const GetWebcastViewerSlidesNewAuthDocument = gql`
  query GetWebcastViewerSlidesNewAuth($webcastId: ID!) {
    webcastNewAuth(webcastId: $webcastId) {
      id
      presentations {
        language
        groupId
        slides {
          index
          downloadUrl
          thumbnailDownloadUrl
        }
      }
      currentSlide {
        groupId
        index
      }
      pushedSlides {
        groupId
        index
        offsetInMs
      }
    }
  }
`;

/**
 * __useGetWebcastViewerSlidesNewAuthQuery__
 *
 * To run a query within a React component, call `useGetWebcastViewerSlidesNewAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebcastViewerSlidesNewAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebcastViewerSlidesNewAuthQuery({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function useGetWebcastViewerSlidesNewAuthQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWebcastViewerSlidesNewAuthQuery,
    GetWebcastViewerSlidesNewAuthQueryVariables
  > &
    ({ variables: GetWebcastViewerSlidesNewAuthQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWebcastViewerSlidesNewAuthQuery, GetWebcastViewerSlidesNewAuthQueryVariables>(
    GetWebcastViewerSlidesNewAuthDocument,
    options
  );
}
export function useGetWebcastViewerSlidesNewAuthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWebcastViewerSlidesNewAuthQuery,
    GetWebcastViewerSlidesNewAuthQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWebcastViewerSlidesNewAuthQuery, GetWebcastViewerSlidesNewAuthQueryVariables>(
    GetWebcastViewerSlidesNewAuthDocument,
    options
  );
}
// @ts-ignore
export function useGetWebcastViewerSlidesNewAuthSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWebcastViewerSlidesNewAuthQuery,
    GetWebcastViewerSlidesNewAuthQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetWebcastViewerSlidesNewAuthQuery, GetWebcastViewerSlidesNewAuthQueryVariables>;
export function useGetWebcastViewerSlidesNewAuthSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWebcastViewerSlidesNewAuthQuery, GetWebcastViewerSlidesNewAuthQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetWebcastViewerSlidesNewAuthQuery | undefined,
  GetWebcastViewerSlidesNewAuthQueryVariables
>;
export function useGetWebcastViewerSlidesNewAuthSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWebcastViewerSlidesNewAuthQuery, GetWebcastViewerSlidesNewAuthQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWebcastViewerSlidesNewAuthQuery, GetWebcastViewerSlidesNewAuthQueryVariables>(
    GetWebcastViewerSlidesNewAuthDocument,
    options
  );
}
export type GetWebcastViewerSlidesNewAuthQueryHookResult = ReturnType<typeof useGetWebcastViewerSlidesNewAuthQuery>;
export type GetWebcastViewerSlidesNewAuthLazyQueryHookResult = ReturnType<
  typeof useGetWebcastViewerSlidesNewAuthLazyQuery
>;
export type GetWebcastViewerSlidesNewAuthSuspenseQueryHookResult = ReturnType<
  typeof useGetWebcastViewerSlidesNewAuthSuspenseQuery
>;
export type GetWebcastViewerSlidesNewAuthQueryResult = Apollo.QueryResult<
  GetWebcastViewerSlidesNewAuthQuery,
  GetWebcastViewerSlidesNewAuthQueryVariables
>;
export const CompleteAuthStepsDocument = gql`
  mutation CompleteAuthSteps($input: CompleteAuthStepsInput!) {
    completeAuthSteps(input: $input) {
      ... on CompletedAuthSteps {
        accessGranted
        sessionToken
        pathways {
          requiredNextSteps
          isInProgress
        }
        failedSteps {
          stepType
          reason
        }
      }
      ... on CompleteAuthStepsProblem {
        code
      }
    }
  }
`;
export type CompleteAuthStepsMutationFn = Apollo.MutationFunction<
  CompleteAuthStepsMutation,
  CompleteAuthStepsMutationVariables
>;

/**
 * __useCompleteAuthStepsMutation__
 *
 * To run a mutation, you first call `useCompleteAuthStepsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAuthStepsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAuthStepsMutation, { data, loading, error }] = useCompleteAuthStepsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteAuthStepsMutation(
  baseOptions?: Apollo.MutationHookOptions<CompleteAuthStepsMutation, CompleteAuthStepsMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CompleteAuthStepsMutation, CompleteAuthStepsMutationVariables>(
    CompleteAuthStepsDocument,
    options
  );
}
export type CompleteAuthStepsMutationHookResult = ReturnType<typeof useCompleteAuthStepsMutation>;
export type CompleteAuthStepsMutationResult = Apollo.MutationResult<CompleteAuthStepsMutation>;
export type CompleteAuthStepsMutationOptions = Apollo.BaseMutationOptions<
  CompleteAuthStepsMutation,
  CompleteAuthStepsMutationVariables
>;
